import React, { useState, useEffect } from "react";
import { withStyles, Grid, InputLabel, Switch } from "@material-ui/core";
import { getGeographies } from "../../../../../../API/Country";
import { styles } from "./styles";

import TextField from "../../../../../../Component/Forms/TextField";
import SearchableSelect from "../../../../../../Component/Forms/SearchableSelect";
import { useTranslation } from "react-i18next";

const CountryForm = (props) => {
  const { country = {}, onFieldChange, formErrors, classes } = props;
  const { t } = useTranslation();

  const jllCoveredOptions = [
    {
      label: t("labels.common.yes"),
      value: "Yes",
    },
    {
      label: t("labels.common.no"),
      value: "No",
    },
    {
      label: "IFM",
      value: "IFM",
    },
  ];
  const [regions, setRegions] = useState([]);
  const [region, setRegion] = useState(null);
  const [jllCovered, setjJllCovered] = useState(null);
  const [mdmSupported, setMdmSupported] = useState(false);
  const [jllCountry, setJllCountry] = useState(false);
  const [illegal, setIllegal] = useState(false);

  useEffect(() => {
    const loadGeographies = async () => {
      try {
        const result = await getGeographies();
        const { data = [] } = result;
        const regions = data.map((val) => ({ value: val.id, label: val.name }));
        setRegions(regions);
        setRegion(regions.find((r) => r.value === country["parent_id"]));
      } catch (error) {
        console.log(error);
      }
    };
    loadGeographies();
    setMdmSupported(country["supports_mdm"] || false);
    setJllCountry(country["is_jll_country"] || false);
    setIllegal(country["illegal"] || false);
    setjJllCovered(jllCoveredOptions.find((r) => r.value === country["jll_covered"]))
  }, [country]);

  const handleChange = (value, name) => {
    onFieldChange && onFieldChange(value, name);
  };

  const handleRegionChange = (r) => {
    setRegion(r);
    onFieldChange && onFieldChange(r ? r.value : null, "parent_id");
  };
  
  const handleJllCoveredChange = (j) => {
    setjJllCovered(j);
    onFieldChange && onFieldChange(j ? j.value : null, "jll_covered");
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.name")}
          required={true}
          type="text"
          initialValue={country["name"]}
          onChange={(value) => handleChange(value, "name")}
        />
        {formErrors["name"] && <div className={classes.errorText}>{formErrors["name"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.isoCode2")}
          required={true}
          type="text"
          initialValue={country["iso_code_2"]}
          onChange={(value) => handleChange(value, "iso_code_2")}
        />
        {formErrors["iso_code_2"] && <div className={classes.errorText}>{formErrors["iso_code_2"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.isoCode3")}
          required={true}
          type="text"
          initialValue={country["iso_code_3"]}
          onChange={(value) => handleChange(value, "iso_code_3")}
        />
        {formErrors["iso_code_3"] && <div className={classes.errorText}>{formErrors["iso_code_3"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <SearchableSelect
          label={t("labels.country.basicInformation.countryForm.region")}
          options={regions}
          value={region}
          changeHandler={handleRegionChange}
          disableClearable={true}
          required={true}
        />
        {formErrors["Region"] && <div className={classes.errorText}>{formErrors["Region"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <InputLabel className={classes.inputLabel}>{t("labels.country.basicInformation.countryForm.supportsMdm")}</InputLabel>
        <Switch
          checked={mdmSupported}
          disableRipple
          color="primary"
          classes={{
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          onChange={(e) => {
            const checked = e.target.checked;
            setMdmSupported(checked);
            handleChange(checked, "supports_mdm");
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <InputLabel className={classes.inputLabel}>{t("labels.country.basicInformation.countryForm.isJllCountry")}</InputLabel>
        <Switch
          checked={jllCountry}
          disableRipple
          color="primary"
          classes={{
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          onChange={(e) => {
            const checked = e.target.checked;
            setJllCountry(checked);
            handleChange(checked, "is_jll_country");
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <InputLabel className={classes.inputLabel}>{t("labels.country.basicInformation.countryForm.isIllegal")}</InputLabel>
        <Switch
          checked={illegal}
          disableRipple
          color="primary"
          classes={{
            switchBase: classes.switchBase,
            thumb: classes.thumb,
            track: classes.track,
            checked: classes.checked,
          }}
          onChange={(e) => {
            const checked = e.target.checked;
            setIllegal(checked);
            handleChange(checked, "illegal");
          }}
        />
      </Grid>
      <Grid item xs={3}>
        <SearchableSelect
          label={t("labels.country.basicInformation.countryForm.isJllCovered")}
          options={jllCoveredOptions}
          value={jllCovered}
          changeHandler={handleJllCoveredChange}
          disableClearable={true}
        />
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.mlroContactNames")}
          labelErrorText={""}
          type="text"
          initialValue={country["mlro_contact_names"]}
          onChange={(value) => handleChange(value, "mlro_contact_names")}
        />
        {formErrors["mlro_contact_names"] && <div className={classes.errorText}>{formErrors["mlro_contact_names"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.mlroContactEmails")}
          type="text"
          initialValue={country["mlro_contact_emails"]}
          onChange={(value) => handleChange(value, "mlro_contact_emails")}
        />
        {formErrors["mlro_contact_emails"] && <div className={classes.errorText}>{formErrors["mlro_contact_emails"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.mlroDelegateNames")}
          initialValue={country["mlro_delegate_names"]}
          type="text"
          onChange={(value) => handleChange(value, "mlro_delegate_names")}
        />
        {formErrors["mlro_delegate_names"] && <div className={classes.errorText}>{formErrors["mlro_delegate_names"]}</div>}
      </Grid>
      <Grid item xs={3}>
        <TextField
          label={t("labels.country.basicInformation.countryForm.mlroDelegateEmails")}
          initialValue={country["mlro_delegate_emails"]}
          type="text"
          onChange={(value) => handleChange(value, "mlro_delegate_emails")}
          error={formErrors["mlro_delegate_emails"]}
          helperText={formErrors["mlro_delegate_emails"]}
        />
        {formErrors["mlro_delegate_emails"] && <div className={classes.errorText}>{formErrors["mlro_delegate_emails"]}</div>}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles, { withTheme: true })(CountryForm);
